<template>
	<router-link active-class="active" :to="navigateTo" class="tab-button flex-centerize">
		{{ tab.text }}
	</router-link>
</template>

<script>
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';
export default {
	name: 'ManageAndCreateTab',
	props: {
		tab: { type: Object },
	},
	computed: {
		placementModePrefixName() {
			return CreateAndManageService.getPlacementRoutePrefix(this.$route);
		},
		navigateTo() {
			if (this.placementModePrefixName) {
				return { name: this.placementModePrefixName + this.tab.routeName };
			} else {
				return { name: this.tab.routeName };
			}
		},
	},
};
</script>
<style scoped lang="scss">
.tab-button {
	text-decoration: none;
	padding: 0px 2px;
	height: 70px;
	background: transparent;

	font-size: 14px;
	border-radius: 0px;
	letter-spacing: 0px;
	color: #262626e8;
	font-weight: normal !important;
	&:hover,
	&.active {
		color: black;
	}
	&.active {
		border-bottom: 2px solid #282828;
	}
}
</style>
